import { motion, useAnimation } from 'framer-motion'
import React from 'react'
import { ReactComponent as AudioIcon } from '../images/icons/audio_product.svg'

const HoverMedia = ({
  src,
  className,
  type,
  scale = true,
}: {
  src: string
  className?: string
  type: 'video' | 'audio' | 'image'
  scale?: boolean
}): JSX.Element => {
  const mediaRef = React.useRef<HTMLVideoElement | null>(null)
  const [videoOnHover, setVideoOnHover] = React.useState<boolean>(false)
  const controls = useAnimation()

  const handleHoverStart = (): void => {
    if (mediaRef.current) mediaRef.current.play()
    setVideoOnHover(true)

    controls.start({ opacity: 1, scale: scale ? 1.2 : 1 })
  }

  const handleHoverEnd = (): void => {
    if (mediaRef.current) mediaRef.current.pause()
    setVideoOnHover(false)

    controls.start({ opacity: 1, scale: 1 })
  }

  return (
    <div
      onMouseEnter={handleHoverStart}
      onMouseLeave={handleHoverEnd}
      className="relative">
      {type === 'video' && (
        <motion.video
          ref={mediaRef}
          src={src}
          className={className}
          animate={controls}
          preload={'auto'}
          controls={videoOnHover}
        />
      )}
      {type === 'audio' && (
        <>
          <motion.div animate={controls}>
            <AudioIcon />
          </motion.div>
          <motion.audio ref={mediaRef} className={className} src={src} />
        </>
      )}
      {type === 'image' && (
        <motion.img
          loading="lazy"
          src={src}
          className={`rounded-xl w-fit h-fit object-cover object-scale-down max-h-40`}
        />
      )}
    </div>
  )
}

export default HoverMedia
